import { render, staticRenderFns } from "./FriendlyDate.vue?vue&type=template&id=49f97148&"
import script from "./FriendlyDate.vue?vue&type=script&lang=js&"
export * from "./FriendlyDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports